import React from 'react';
import GeoPageTemplate from '../components/GeoPageTemplate';
import geoConfigs from '../config/geoConfigs';

const LocacaoContagem = () => {
  return <GeoPageTemplate {...geoConfigs.contagem} />;
};

export default LocacaoContagem;